import { ensureAll as ensureAllbuses } from '../store/busesSlice';
import { ensureAll as ensureAllDrivers } from '../store/driversSlice';
import { ensureAll as ensureAllFoodPackages } from '../store/foodPackagesSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { URL_PREFIX } from '../api';
import { useEffect } from 'react';
import { useModals } from '@mattjennings/react-modal-stack';
import BusModal from './BusModal';
import DriverModal from './DriverModal';

import './Resources.css';
import Section from '../components/Section';
import FoodPackageModal from './FoodPackageModal';


function Resources() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { openModal } = useModals();

    const _buses = useSelector((state) => state.buses.knownBuses);
    const buses = Object.values(_buses).sort((a, b) => a.bus_name.localeCompare(b.bus_name));
    const _drivers = useSelector((state) => state.drivers.knownDrivers);
    const drivers = Object.values(_drivers).sort((a, b) => a.driver_firstname.localeCompare(b.driver_firstname + b.driver_lastname));
    const _foodPackages = useSelector((state) => state.foodPackages.knownFoodPackages);
    const foodPackages = Object.values(_foodPackages).sort((a, b) => a.food_package_name.localeCompare(b.food_package_name));

    useEffect(() => {
        dispatch(ensureAllbuses());
        dispatch(ensureAllDrivers());
        dispatch(ensureAllFoodPackages());
    }, []);

    return (
        <div className="column g32 p32">
            <div className="column g32">
                <div className="column">
                    <h1>Juhid</h1>
                    <p>Vajuta peale, et muuta.</p>
                </div>
                <div className="line g32">
                    { drivers.map(driver => (!driver.driver_hidden) && (
                        <div className="column g8 center p16" style={{ border: '1px solid #ddd', borderRadius: 4 }}>
                            <div className="w100 column center-cross">
                                <img
                                    src={URL_PREFIX + "/storage/driver/" + driver.driver_id.toLowerCase() + ".jpg"}
                                    style={{ objectFit: 'cover', width: 64, height: 64, borderRadius: 32 }}
                                />
                            </div>
                            <p>{driver.driver_firstname}</p>
                            <button className='borderless' onClick={() => openModal(DriverModal, { id: driver.driver_id })}>Muuda</button>
                        </div>
                    )) }

                    <div className="row center-cross">
                        <svg onClick={() => navigate("/platform/createUser")} className='add-plus' width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_947_174)"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM25.25 25.25V11H34.75V25.25H49V34.75H34.75V49H25.25V34.75H11V25.25H25.25Z"/></g><defs><clipPath id="clip0_947_174"><rect width="60" height="60" fill="white"/></clipPath></defs></svg>
                    </div>
                </div>

                {(drivers.some(driver => driver.driver_hidden)) && (
                    <Section title="Peidetud juhid" initiallyHidden={true}>
                        <div className="line g32">
                            { drivers.map(driver => (!!driver.driver_hidden) && (
                                <div className="column g8 center p16" style={{ border: '1px solid #ddd', borderRadius: 4 }}>
                                    <div className="w100 column center-cross">
                                        <img
                                            src={URL_PREFIX + "/storage/driver/" + driver.driver_id.toLowerCase() + ".jpg"}
                                            style={{ objectFit: 'cover', width: 64, height: 64, borderRadius: 32 }}
                                        />
                                    </div>
                                    <p>{driver.driver_firstname}</p>
                                    <button className='borderless' onClick={() => openModal(DriverModal, { id: driver.driver_id })}>Muuda</button>
                                </div>
                            )) }
                        </div>
                    </Section>
                )}
            </div>

            <div className="column g32">
                <div className="column">
                    <h1>Bussid</h1>
                    <p>Vajuta peale, et muuta.</p>
                </div>
                <div className="line g32">
                    { buses.map(bus => (!bus.bus_hidden) && (
                        <div className="column g8 start-cross p16" style={{ border: '1px solid #ddd', borderRadius: 4 }}>
                            <img
                                src={URL_PREFIX + "/storage/bus/" + bus.bus_id.toLowerCase() + ".jpg"}
                                style={{ objectFit: 'cover', width: 128, height: 96, borderRadius: 4 }}
                            />
                            <p>{bus.bus_name}</p>
                            <button className='borderless' onClick={() => openModal(BusModal, { id: bus.bus_id })}>Muuda</button>
                        </div>
                    )) }

                    <div className="row center-cross">
                        <svg onClick={() => navigate("/platform/createBus")} className='add-plus' width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_947_174)"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM25.25 25.25V11H34.75V25.25H49V34.75H34.75V49H25.25V34.75H11V25.25H25.25Z"/></g><defs><clipPath id="clip0_947_174"><rect width="60" height="60" fill="white"/></clipPath></defs></svg>
                    </div>
                </div>

                {(buses.some(bus => bus.bus_hidden)) && (
                    <Section title="Peidetud bussid" initiallyHidden={true}>
                        <div className="line g32">
                            { buses.map(bus => (!!bus.bus_hidden) && (
                                <div className="column g8 start-cross p16" style={{ border: '1px solid #ddd', borderRadius: 4 }}>
                                    <img
                                        src={URL_PREFIX + "/storage/bus/" + bus.bus_id.toLowerCase() + ".jpg"}
                                        style={{ objectFit: 'cover', width: 128, height: 96, borderRadius: 4 }}
                                    />
                                    <p>{bus.bus_name}</p>
                                    <button className='borderless' onClick={() => openModal(BusModal, { id: bus.bus_id })}>Muuda</button>
                                </div>
                            )) }
                        </div>
                    </Section>
                )}
            </div>

            <div className="column g32">
                <div className="column">
                    <h1>Toitlustuspaketid</h1>
                    <p>Vajuta peale, et muuta.</p>
                </div>
                <div className="line g32">
                    { foodPackages.map(foodPackage => (!foodPackage.food_package_hidden) && (
                        <div className="column g8 start-cross p16" style={{ border: '1px solid #ddd', borderRadius: 4 }}>
                            <img
                                src={URL_PREFIX + "/storage/food_package/" + foodPackage.food_package_id.toLowerCase() + ".jpg"}
                                style={{ objectFit: 'cover', width: 128, height: 96, borderRadius: 4 }}
                            />
                            <p>{foodPackage.food_package_name}</p>
                            <button className='borderless' onClick={() => openModal(FoodPackageModal, { id: foodPackage.food_package_id })}>Muuda</button>
                        </div>
                    )) }

                    <div className="row center-cross">
                        <svg onClick={() => navigate("/platform/addFoodPackage")} className='add-plus' width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_947_174)"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM25.25 25.25V11H34.75V25.25H49V34.75H34.75V49H25.25V34.75H11V25.25H25.25Z"/></g><defs><clipPath id="clip0_947_174"><rect width="60" height="60" fill="white"/></clipPath></defs></svg>
                    </div>
                </div>

                {(foodPackages.some(foodPackage => foodPackage.food_package_hidden)) && (
                    <Section title="Peidetud toitlustuspaketid" initiallyHidden={true}>
                        <div className="line g32">
                            { foodPackages.map(foodPackage => (!!foodPackage.food_package_hidden) && (
                                <div className="column g8 start-cross p16" style={{ border: '1px solid #ddd', borderRadius: 4 }}>
                                    <img
                                        src={URL_PREFIX + "/storage/food_package/" + foodPackage.food_package_id.toLowerCase() + ".jpg"}
                                        style={{ objectFit: 'cover', width: 128, height: 96, borderRadius: 4 }}
                                    />
                                    <p>{foodPackage.food_package_name}</p>
                                    <button className='borderless' onClick={() => openModal(FoodPackageModal, { id: foodPackage.food_package_id })}>Muuda</button>
                                </div>
                            )) }
                        </div>
                    </Section>
                )}

            </div>
        </div>
    )
}

export default Resources;